<template>
  <modal-action-form ref="modal" :modal-id="modalId"
                     :title="i18n.t('member.forums.new_flag.title')"
                     :submit-action="createFlagAction" @clear="clear">
    <template #body>
      <div class="mb20">
        {{ i18n.t('member.forums.new_flag.description') }}
      </div>
      <text-input input-id="reason" :label="i18n.t('member.forums.new_flag.reason')" multiline :value="reason" @changed="setReason" />
    </template>
  </modal-action-form>
</template>

<script>
import ModalActionForm from '../components/modal-action-form'
import TextInput from '../components/inputs/text-input'

export default {
  components: { ModalActionForm, TextInput },

  props: {
    messageId: {
      type: Number,
      required: true
    },
    threadId: {
      type: Number,
      required: true
    },
    modalId: {
      type: String,
      required: true
    },
    flagActionName: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      reason: ''
    }
  },

  methods: {
    clear() {
      this.reason = ''
    },
    createFlagAction() {
      return this.$store.dispatch(this.flagActionName, {threadId: this.threadId, messageId: this.messageId, reason: this.reason})
    },
    setReason(reason) {
      this.reason = reason
    },
    open() {
      this.$refs.modal.open()
    }
  }
}
</script>
